import { render } from "./Settings.vue?vue&type=template&id=62afe8e4"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/profile/Settings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "62afe8e4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('62afe8e4', __exports__)) {
    api.reload('62afe8e4', __exports__)
  }
  
  module.hot.accept("./Settings.vue?vue&type=template&id=62afe8e4", () => {
    api.rerender('62afe8e4', render)
  })

}


export default __exports__